import { ThemeInterface } from "@styles/theme";

const styles = (theme: ThemeInterface) => ({
	boxRoot: {
		outline: 0,
		position: "absolute" as "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		borderRadius: "2px",
		boxShadow:
			"0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14)",
		backgroundColor: theme.palette.grey[50],
	},
});

export default styles;
